<template>
  <div class="resoc">
    <Menu />
    <div class="re_cont">
      <div class="bnr" ref="bnr">
        <img class="bnr_pic" src="@/assets/resourceCenter/bnr@2x.png" alt="" />
        <div class="bnr_bx">
          <h1 class="title">资源中心</h1>
          <p class="desc">
            了解远控最新趋势、行业标杆案例、前沿技术应用<br />与我们携手探索更多远程可能
          </p>
        </div>
      </div>
      <div class="tab_bx" :class="{ fixed: tabFixd }" v-if="cmsList.length > 0">
        <div class="tabs" :class="{ active: show_tabs }">
          <p
            class="tab_item"
            :class="{ active: active_tab == index }"
            v-for="(item, index) in cmsList"
            :key="index"
            @click="changeTab(index)"
          >
            {{ item.tag_name }}
          </p>
          <p class="line"></p>
          <div class="tab_lay" v-if="show_tabs"></div>
        </div>
        <div class="icon_bx" @click="show_tabs = !show_tabs">
          <img
            class="icon"
            :class="show_tabs ? 'active' : ''"
            src="@/assets/resourceCenter/top-arrow.svg"
            alt=""
          />
        </div>
        <div class="tabs_show_bx" v-show="show_tabs">
          <p
            class="tabs_show_item"
            :class="{ active: active_tab == index }"
            v-for="(item, index) in cmsList"
            :key="index"
            @click="changeTab(index)"
          >
            {{ item.tag_name }}
          </p>
        </div>
      </div>

      <div class="cont">
        <div
          v-for="(item, index) in cmsList"
          :key="index"
          :id="`tag` + index"
          class="atc_item"
        >
          <div class="item_top">
            <p class="title">{{ item.tag_name }}</p>
            <router-link
              target="_self"
              :to="`/news?tag_id=${item.tag_id}&title=${item.tag_name}`"
              class="more"
              v-show="item.total > 4"
            >
              <span>查看更多</span>
              <img src="@/assets/resourceCenter/to_right@2x.png" alt="" />
            </router-link>
          </div>
          <div class="item_bx">
            <router-link
              target="_self"
              :to="`/news/${item2.id}`"
              class="sub_item"
              v-for="(item2, index2) in item.article"
              :key="index2"
            >
              <div class="pic_bx">
                <img
                  class="main_pic"
                  :src="item2.article_image"
                  :alt="item2.title"
                />
                <img
                  :class="{ active: item2.is_hot == 1 }"
                  src="@/assets/resourceCenter/hot@2x.png"
                  alt=""
                  class="hot_icon"
                />
              </div>
              <div class="info">
                <p class="item_title">{{ item2.article_title }}</p>
                <div class="sub_info">
                  <p class="item_date">{{ item2.release_time | formatTime }}</p>
                  <div class="views">
                    <img
                      src="@/assets/resourceCenter/view@2x.png"
                      alt=""
                      class="view_icon"
                    />
                    <span class="viem_nm">{{ item2.browse_count }}</span>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      cms: [],
      active_tab: 0,
      tabFixd: false,
      tabsOffsetTop: 0,
      tabsOffsetHeight: 0,
      noTab: true,
      show_tabs: false,
    };
  },
  created() {
    this.$store.commit("setMenuShadow", false);
  },
  async mounted() {
    await this.getData();
    window.scrollTo(0, 0);
    this.$nextTick(() => {
      this.setTab();
    });
  },
  methods: {
    async getData() {
      try {
        let res = await this.$serve.getResource();
        this.cms = res.data.list;
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
    setTab() {
      window.addEventListener("scroll", () => {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        this.tabFixd = scrollTop > this.$refs.bnr.offsetHeight + 50;
      });
    },
    changeTab(index) {
      this.show_tabs = false;
      let idTop = document.getElementById("tag" + index).offsetTop - 100;
      if (index == 0) {
        idTop = 0;
      }
      if (this.noTab) {
        idTop = idTop - 44;
        this.noTab = false;
      }
      window.scrollTo(0, idTop);
      this.active_tab = index;
      if (this.active_tab == 0) {
        this.noTab = true;
      }
    },
  },
  computed: {
    cmsList: function () {
      return this.cms.filter((item) => {
        return item.article.length > 0;
      });
    },
  },
  filters: {
    formatTime(data) {
      return data.split(".")[0].split("T")[0];
    },
  },
  beforeDestroy() {
    this.$store.commit("setMenuShadow", true);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.resoc {
  background: #fff;
  .bnr {
    position: relative;
    height: 276px;
    .bnr_pic {
      width: 100%;
      height: auto;
      display: block;
    }
    .bnr_bx {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      text-align: center;
      box-sizing: border-box;
      padding-bottom: 24px;
      .title {
        font-size: 34px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222429;
      }
      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #585f69;
        line-height: 20px;
        margin-top: 8px;
      }
    }
  }
  .tab_bx {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    height: 44px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
    &.fixed {
      position: fixed;
      left: 0;
      top: 50px;
      z-index: 2;
    }
    .icon_bx {
      width: 47px;
      height: 100%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 16px;
        height: 16px;
        -ms-transform: rotate(0deg); /* IE 9 */
        -webkit-transform: rotate(0deg); /* Safari and Chrome */
        transform: rotate(0deg);
        transition: transform 0.3s;
        &.active {
          -ms-transform: rotate(180deg); /* IE 9 */
          -webkit-transform: rotate(180deg); /* Safari and Chrome */
          transform: rotate(180deg);
          transition: all 0.3s;
        }
      }
    }
    .tabs_show_bx {
      position: absolute;
      top: 44px;
      left: 0;
      width: 100%;
      padding: 4px 16px 10px;
      box-sizing: border-box;
      background: #fff;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      z-index: 1;
      .tabs_show_item {
        width: 50%;
        display: inline-block;
        font-size: 14px;
        color: #181818;
        line-height: 22px;
        padding: 4px 8px;
        box-sizing: border-box;
        &.active {
          color: #016efd;
        }
      }
    }
  }
  .tabs {
    flex: 1;
    background: #fff;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 1px;
    position: relative;
    &.active {
      overflow: hidden;
    }
    .tab_lay {
      left: 0;
      top: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      background: #fff;
    }
    .tab_item {
      height: 44px;
      line-height: 42px;
      box-sizing: border-box;
      display: inline-block;
      padding-left: 20px;
      padding-right: 20px;
      color: #5e6166;
      font-size: 14px;
      border-bottom: 2px solid #fff;
      position: relative;
      &.active {
        color: #016efd;
        border-color: #016efd;
      }
      &:before {
        content: "";
        display: inline-block;
        width: 1px;
        position: absolute;
        top: 15px;
        bottom: 15px;
        background-color: #d6dbe3;
        left: 0;
      }
    }
  }
  .cont {
    padding-left: 13px;
    padding-right: 13px;
    padding-bottom: 20px;
    .atc_item {
      padding-top: 24px;
      padding-bottom: 20px;
      .item_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
        }
        .more {
          display: flex;
          align-items: center;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #016efd;
          }
          img {
            width: 8px;
            height: auto;
          }
          &:active {
            opacity: 0.8;
          }
        }
      }
      .item_bx {
        display: flex;
        flex-flow: row wrap;
        // justify-content: space-between;
        margin-top: 14px;
        .sub_item {
          width: 168px;
          height: 175px;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.12);
          border-radius: 4px;
          margin-top: 11px;
          position: relative;
          top: 0;
          margin-right: 11px;
          overflow: hidden;
          .pic_bx {
            position: relative;
            font-size: 0;
            .main_pic {
              width: 100%;
              height: 86px;
            }
            .hot_icon {
              position: absolute;
              right: -4px;
              top: 0;
              width: 47px;
              height: auto;
              display: none;
            }
            .hot_icon.active {
              display: block;
            }
          }
          .info {
            padding: 8px 8px 0 8px;
            .item_title {
              font-size: 13px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              height: 36px;
              -webkit-line-clamp: 2;
              word-wrap: break-word;
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }
            .sub_info {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 12px;
              .item_date {
                font-size: 11px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #83888f;
              }
              .views {
                display: flex;
                align-items: center;
                .view_icon {
                  width: 12px;
                  height: auto;
                }
                .viem_nm {
                  margin-left: 2px;
                  font-size: 11px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #83888f;
                }
              }
            }
          }
        }
        .sub_item:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
